import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ManageAlerts from "./manageAlerts/manageAlerts";
import NotificationHistory from "./notificationHistory/notificationHistory";
import { fetchPushNotifications } from "../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Loader from "../../components/loader";
import { saveNotificationsData } from "../../store/slice/notificationSlice";

const Notifications = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Manage Alerts");
  const [activeAndPendingNotifs, setActiveAndPendingNotifs] = useState([]);
  const [expiredNotifs, setExpiredNotifs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    fetchAllNotifs();
  }, []);

  const fetchAllNotifs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchPushNotifications, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      dispatch(saveNotificationsData(response?.data));
      const tableData = response?.data?.map((row) => ({
        id: row?.id,
        type: row?.notificationType,
        title: row?.title,
        description: row?.text,
        status: row?.status,
        datetime: row?.triggerTime,
        users: row?.userPlan,
      }));
      const activeAndPendingAlerts = tableData?.filter(
        (notification) =>
          notification?.status == "PENDING" || notification?.status == "ACTIVE"
      );
      setActiveAndPendingNotifs(activeAndPendingAlerts);

      const expiredAlerts = tableData?.filter(
        (notification) => notification?.status == "EXPIRED"
      );
      setExpiredNotifs(expiredAlerts);
    } catch (error) {
      console.error("Error fetching push notifications", error);
      toast.error("Error fetching push notifications");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="px-md-2 px-1 py-md-2 py-1">
        {/* <h2>Notifications</h2> */}
        <ul className="nav nav-tabs">
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${
                activeTab === "Manage Alerts" ? "active" : ""
              }`}
              onClick={() => setActiveTab("Manage Alerts")}
              style={{
                color: activeTab !== "Manage Alerts" ? "#2c3e50" : "",
                fontWeight: activeTab == "Manage Alerts" ? "600" : "normal",
                fontSize: activeTab == "Manage Alerts" ? "large" : "medium",
              }}
            >
              Manage Alerts
            </a>
          </li>
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${
                activeTab === "Alerts History" ? "active" : ""
              }`}
              onClick={() => setActiveTab("Alerts History")}
              style={{
                color: activeTab !== "Alerts History" ? "#2c3e50" : "",
                fontWeight: activeTab == "Alerts History" ? "600" : "normal",
                fontSize: activeTab == "Alerts History" ? "large" : "medium",
              }}
            >
              Notification History
            </a>
          </li>
        </ul>
        {activeTab === "Manage Alerts" && (
          <ManageAlerts
            alerts={activeAndPendingNotifs}
            fetchData={fetchAllNotifs}
          />
        )}
        {activeTab === "Alerts History" && (
          <NotificationHistory alerts={expiredNotifs} />
        )}
      </div>
      {loading && <Loader />}
    </>
  );
};

export default Notifications;
